import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import { debounce } from "lodash";
import axios from "axios";

import { addEntities } from "../../entities";
import {
  QUERY_INVITED_CARRIERS_REQUEST,
  QUERY_INVITED_CARRIERS_SUCCESS,
  QUERY_INVITED_CARRIERS_FAILURE
} from "../types";

const handleResponse = (
  response,
  dispatch,
  groupMember,
  limit,
  offset,
  ordering,
  filters
) => {
  const data = normalize(response.results, [groupMember]);
  dispatch(addEntities(data.entities));
  dispatch(
    createAction(QUERY_INVITED_CARRIERS_SUCCESS)({
      items: data.result,
      count: response.count,
      next: response.next,
      previous: response.previous,
      ordering,
      limit,
      offset,
      filters
    })
  );
  return response;
};

const debounced = debounce(
  async (dispatch, schema, api, limit, offset, ordering, filters) => {
    dispatch(
      createAction(QUERY_INVITED_CARRIERS_REQUEST)({
        limit,
        offset,
        filters,
        ordering
      })
    );
    const response = await api.groups.queryInvitedCarriers(
      limit,
      offset,
      ordering,
      filters
    );
    handleResponse(
      response,
      dispatch,
      schema.paymentProfile,
      limit,
      offset,
      ordering,
      filters
    );
  },
  1000,
  { trailing: true }
);

export const next = (link, limit, offset, ordering, filters) => async (
  dispatch,
  getState,
  { schema }
) => {
  try {
    dispatch(
      createAction(QUERY_INVITED_CARRIERS_REQUEST)({
        limit,
        ordering,
        filters
      })
    );

    const response = await axios.get(link);
    handleResponse(
      response.data,
      dispatch,
      schema.paymentProfile,
      limit,
      offset,
      ordering,
      filters
    );
  } catch (err) {
    dispatch(createAction(QUERY_INVITED_CARRIERS_FAILURE)(err));
    throw err;
  }
};

const queryInvitedCarriers = (limit, offset, ordering, filters = {}) => async (
  dispatch,
  getState,
  { api, schema }
) => {
  try {
    await debounced(dispatch, schema, api, limit, offset, ordering, filters);
  } catch (err) {
    dispatch(createAction(QUERY_INVITED_CARRIERS_FAILURE)(err));
    throw err;
  }
};

export default queryInvitedCarriers;
